import { render, staticRenderFns } from "./BookingDetailContainer.vue?vue&type=template&id=1b100e34&"
import script from "./BookingDetailContainer.vue?vue&type=script&lang=js&"
export * from "./BookingDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports